export const COLORS = {
  primary: "#9685FF",
  secondary: "#F9F8FF",
  tertiary: "#EBEBFC",
  background: "#FFFFFF",
  text: "#333333",
  white: "#FFFFFF",
  error: "#FF3B30",
  gradientStart: "#d7a6e3",
  gradientEnd: "#d7a6e3",
  gray: "#7F8C8D",
  lightGray: "#b5b5b5",
};
